import { Injectable, inject } from '@angular/core';
import { BaseCommandRepository } from '@okcargo-apps/shared-infrastructure';
import { UploadCompanyDocumentCommand, UploadCompanyDocumentCommandHandler } from '@okcargo/command-processor';

@Injectable({ providedIn: 'root' })
export class DocumentUploaderCommandService {
  private readonly commandRepository = inject(BaseCommandRepository);

  private readonly uploadCompanyDocumentCommandHandler: UploadCompanyDocumentCommandHandler;
  // private readonly reUploadCompanyDocumentCommandHandler: ReUploadCompanyDocumentCommandHandler;

  constructor() {
    const commandRepository = this.commandRepository;

    this.uploadCompanyDocumentCommandHandler = new UploadCompanyDocumentCommandHandler(commandRepository);
    // this.reUploadCompanyDocumentCommandHandler = new ReUploadCompanyDocumentCommandHandler(commandRepository);
  }

  uploadCompanyDocument(command: UploadCompanyDocumentCommand): Promise<void> {
    return this.uploadCompanyDocumentCommandHandler.handle(command);
  }

  // reUploadCompanyDocument(command: ReUploadCompanyDocumentCommand): Promise<void> {
  //   return this.reUploadCompanyDocumentCommandHandler.handle(command);
  // }

  // uploadShipperDocument(command: UploadShipperDocumentCommand): Promise<void> {
  //   console.log('Uploading shipper document ', command.documentId);
  //   return this.uploadShipperDocumentCommandHandler.handle(command);
  // }

  // reUploadShipperDocument(command: ReUploadShipperDocumentCommand): Promise<void> {
  //   console.log('ReUploading shipper document ', command.documentId);
  //   return this.reUploadShipperDocumentCommandHandler.handle(command);
  // }

  // importAddresses(command: ImportAddressBatchCommand): Promise<void> {
  //   return this.importAddressBatchCommandHandler.handle(command);
  // }

  // importVehicles(command: ImportVehicleBatchCommand): Promise<void> {
  //   return this.importVehicleBatchCommandHandler.handle(command);
  // }

  // importEmissions(command: UploadEmissionJourneyBatchCommand): Promise<void> {
  //   return this.uploadEmissionJourneyBatchCommandHandler.handle(command);
  // }
}
